import React from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import Button from '@r1-frontend/ui-react/components/buttons/button';

import urlsForHideConnectButton from '~/src/features/_layout/Header/urlsForHideConnectButton';
import { selectCompanyName } from '~/src/store/selectors/city';

export interface IConnectionAndLoginMainViewProps {
    onOpenBecomeClientPopup: () => void,
}

const MainView = ({ onOpenBecomeClientPopup }: IConnectionAndLoginMainViewProps) => {
    const router = useRouter();
    const companyName = useSelector(selectCompanyName);

    if (urlsForHideConnectButton.includes(router.pathname)) {
        return null;
    }

    return (
        <Button
            bType={'action'}
            size={'medium'}
            onClick={onOpenBecomeClientPopup}
        >
            Подключить {companyName}
        </Button>
    );
};

export default MainView;
